import { render, staticRenderFns } from "./IconbarSidepanel.vue?vue&type=template&id=467fb73e&scoped=true&"
import script from "./IconbarSidepanel.vue?vue&type=script&lang=ts&"
export * from "./IconbarSidepanel.vue?vue&type=script&lang=ts&"
import style0 from "./IconbarSidepanel.vue?vue&type=style&index=0&id=467fb73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467fb73e",
  null
  
)

export default component.exports